module.exports = __webpack_public_path__ + "static/js/1.5c84e5f0.chunk.worker.js"